export default {
  namespaced: true,
  state: {
    component: null,
    title: null,
    props: {},
    bindings: null,
  },
  mutations: {
    SET_PROPS(state, props) {
      state.props = props;
    },
    SET_PROP(state, { key, value }) {
      state.props[key] = value;
    },
    SET_COMPONENT(state, component) {
      state.component = component;
    },
    SET_TITLE(state, title) {
      state.title = title;
    },
    SET_BINDINGS(state, bindings) {
      if (typeof bindings === 'object' && Object.values(bindings).every((binding) => binding instanceof Function)) {
        state.bindings = bindings;
      } else {
        throw new Error('Bindings must be an object of functions');
      }
    },
    CLEAR(state) {
      state.props = {};
      state.component = null;
      state.title = null;
      state.bindings = null;
    },
  },
  getters: {
    GET_PROPS: (state) => state.props || {},
    GET_COMPONENT: (state) => state.component || null,
    GET_TITLE: (state) => state.title || null,
    GET_BINDINGS: (state) => state.bindings || null,
  },
};
